import { render, staticRenderFns } from "./verSolicitudes.vue?vue&type=template&id=21209c28"
import script from "./verSolicitudes.vue?vue&type=script&lang=js"
export * from "./verSolicitudes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports